import Flash from "react-reveal/Flash";

import { HashLink } from "react-router-hash-link";

import React, { useEffect, useState } from "react";
import { Grid, Typography, Box } from "@mui/material";
import Fade from "react-reveal/Fade";
import { useTranslation } from "react-i18next";

const ExpWithPicLeft = ({ smallTitle, title, content, imgUrl, imgHeight }) => {
  const { t, i18n } = useTranslation();
  const [state, setState] = useState(0);
  const handleClick = () => {
    setState((old) => old + 1);
  };
  useEffect(() => {
    setTimeout(() => {
      handleClick();
    }, 2000);
  }, [state]);
  return (
    <Grid
      maxWidth="md"
      container
      sx={{
        width: 1,
        display: "flex",
        alignItems: "center",
        flexDirection: "row",

        ml: "auto",
        mr: "auto",
      }}
    >
      <Grid
        item
        md={6}
        sm={12}
        sx={{
          px: 4,
          py: { md: 6, sm: 10, xs: 10 },
          fontSize: "30px",
          backgroundColor: "#eef4f9",
          height: "600px",
          color: "#5f6566",
        }}
      >
        <Fade delay={300}>
          <Typography
            sx={{ fontSize: "22px", fontWeight: 800, color: "#102840" }}
          >
            {t("index_two_2")}
          </Typography>
        </Fade>
        <Fade delay={400}>
          <Typography
            sx={{
              lineHeight: "170%",
              fontSize: "17px",
            }}
          >
            <Box
              sx={{
                fontSize: "17px",
                pt: 3,
                lineHeight: "1.6em",
                fontWeight: "bold",
                color: "#153a5b",
              }}
            >
              {t("index_two_2_2")}
            </Box>
            <Box sx={{ fontSize: "14px", pt: 2 }}>
              {t("once_wiped")}
              <HashLink to="/product/all-purpose-wipe#silver-colloid">
                <Box sx={{ color: "#153a5b", textDecoration: "underline" }}>
                  {t("learn_more")}
                </Box>
              </HashLink>
            </Box>
            <Box
              sx={{
                fontSize: "17px",
                pt: 3,
                lineHeight: "1.6em",
                fontWeight: "bold",
                color: "#153a5b",
              }}
            >
              {t("rayon")}
            </Box>
            <Box sx={{ pt: 2, fontSize: "14px" }}>
              <Box>{t("rayon_exp")}</Box>

              <HashLink to="/product/all-purpose-wipe#rayon">
                <Box sx={{ color: "#153a5b", textDecoration: "underline" }}>
                  {t("learn_more")}
                </Box>
              </HashLink>
              <button
                className="custom_btn"
                style={{ width: "200px", marginTop: "35px" }}
              >
                <HashLink to="/products-cleansing#top">
                  {t("our_products")}
                </HashLink>
              </button>
            </Box>
          </Typography>
        </Fade>
      </Grid>
      <Grid
        item
        md={6}
        sm={12}
        sx={{
          width: { md: "600px", sm: 1 / 2, xs: 1 },
          height: {
            md: "600px",
            sm: "300px",
            xs: "500px",
          },
          backgroundImage: `url("img/Asset5.png")`,
          backgroundSize: { md: "100% 100%", sm: "100% 100%", xs: "100% 100%" },
          mt: { md: 0, sm: 10, xs: 10 },
        }}
      >
        <Flash spy={state}>
          <img
            src="img/Asset7.png"
            alt=""
            width="40"
            style={{ position: "relative", top: "+60px", left: "+100px" }}
          />
          <img
            src="img/Asset7.png"
            alt=""
            width="40"
            style={{ position: "relative", top: "+80px", left: "+173px" }}
          />
          <img
            src="img/Asset7.png"
            alt=""
            width="40"
            style={{ position: "relative", top: "+50px", left: "+240px" }}
          />
        </Flash>
      </Grid>
    </Grid>
  );
};

export default ExpWithPicLeft;
